import * as React from 'react'

import asyncAction from 'modules/core/lib/asyncAction'

import NewCategoryModal from 'modules/surveys/components/Questions/Categories/NewCategoryModal'
import questionCategories from 'modules/surveys/store/collections/questionCategories'

interface Props {
  formId: number
  onClose: () => void
  questionGroupConfigId: number
}

// TODO: review this interface used in `createQuestionCategory`
// interface DataObject {
//   name: string;
// }
export default function NewCategoryModalContainer({
  questionGroupConfigId,
  onClose,
  formId,
}: Props) {
  const createQuestionCategory = async (data: Record<string, unknown>) => {
    const { success } = await asyncAction(() =>
      questionCategories.create({
        name: data.name,
        surveys_question_group_config_id: questionGroupConfigId,
        surveys_form_id: formId,
      })
    )

    return success
  }

  return <NewCategoryModal onClose={onClose} onSubmit={createQuestionCategory} />
}
